import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["screen"]
  static values  = { active: { type: String, default: "home" } }

  connect() { this.render() }

  show(event) {
    event.preventDefault()
    this.activeValue = event.currentTarget.dataset.screen
    this.render()
    window.scrollTo({ top: 0, behavior: "auto" })
  }

  render() {
    this.screenTargets.forEach((el) => {
      el.dataset.state = el.dataset.screen === this.activeValue ? "active" : "hidden-below"
    })
  }
}
